export default class Api {
    constructor({ url }) {
        // TODO: implement auth
        this.url = url;
    }
    async addQuery(id, query) {
        // await axios.patch(`${this.url}/engine-data/${id}/query-info`, query);
    }
    async create(engineData) {
        // await axios.post(`${this.url}/engine-data`, engineData);
    }
    async patch(id, data) {
        // await axios.patch(`${this.url}/engine-data/${id}`, data);
    }
}
